module.exports = __webpack_public_path__ + "img/gis3.705b5585.png";